<script>
import { API_LOGIN } from '../common/api'

export default {
  created () {
  },
  data () {
    return {
      passwordType: 'password',
      isPassword: true,
      form: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    _togglePasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
        this.isPassword = false
      } else {
        this.passwordType = 'password';
        this.isPassword = true
      }
    },
    loginHandle (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.login()
        }
      })
    },
    login () {
      this.$http.POST(API_LOGIN, {
        account: this.form.account,
        password: this.form.password
      }, res => {
        this.$store.commit('login', res.result.token);
        this.$store.commit('setUser', res.result.user_obj);
        this.$store.commit('setMenu', res.result.menu_list);
        this.$router.push({ path: '/' })
      }, err => {
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<template>
  <div class="login">
    <div class="middle-wrapper">
      <img class="logo" src="../assets/images/logo.png" alt="logo">
      <div class="title">欢迎使用碧源水费系统</div>
      <div class="login-form">
        <el-form
          ref="loginForm"
          :model="form"
          :rules="rules"
          size="medium">
          <el-form-item prop="account">
            <el-input v-model="form.account" placeholder="请输入账号">
              <i slot="prefix" class="iconfont icon-UserService" style="font-size: 16px;"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input :type="passwordType" v-model="form.password" placeholder="请输入密码">
              <i slot="prefix" class="iconfont icon-forgetpassword" style="font-size: 16px;"></i>
              <i slot="suffix" v-bind:class="{ 'iconfont icon-eye': isPassword,
               'iconfont icon-eye1': !isPassword }" style="font-size: 16px;"
                 @click="_togglePasswordType"></i>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0;">
            <el-button
                  type="primary"
                  style="width: 100%;"
                  @click="loginHandle('loginForm')">
                  登 录
                </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="login_bottom">辽ICP备2020014694号-1</div>
  </div>
</template>

<style lang="scss" scoped>
  .login {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #0075A0;

    .middle-wrapper {
      width: 400px;
      margin: 0 auto;
      margin-top: 10%;
      background-color: white;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo {
        margin-top: 50px;
        width: 150px;
      }

      .title {
        margin: 20px 0 10px 0;
        text-align: center;
        font-size: 20px;
        color: #333333;
      }
      .login-form {
        position: relative;
        margin: 0 auto;
        width: 100%;
        padding: 15px 30px 50px 30px;
        box-sizing: border-box;
      }
    }

    .login_bottom {
      text-align: center;
      color: white;
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Login.vue